import { ReactTableHeaderContext } from '../../models/gridReactTable'

export const DefaultFooterCell = (props: ReactTableHeaderContext) => {
  let value = `${props?.getValue?.() ?? ('' as any)}`
  if (value === '[object Object]') {
    value = ''
  }
  return <span>{value}</span>
}
